<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="33"
		viewBox="0 0 32 33"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15.9596 4.70952C16.3501 4.31899 16.9832 4.31899 17.3738 4.70952L28.7071 16.0429C29.0976 16.4334 29.0976 17.0665 28.7071 17.4571L17.3738 28.7904C16.9832 29.1809 16.3501 29.1809 15.9596 28.7904C15.569 28.3999 15.569 27.7667 15.9596 27.3762L25.5858 17.75H4C3.44772 17.75 3 17.3022 3 16.75C3 16.1977 3.44772 15.75 4 15.75H25.5858L15.9596 6.12373C15.569 5.73321 15.569 5.10004 15.9596 4.70952Z"
			fill="white"
		/>
	</svg>
</template>
